const colors = {
  primary: '#CC0000',
  light: '#808080',
  background: '#F3F3F3',
  footer: '#f5f5f5',
  border: '#B6B8BA3E',
  darkBorder: '#B6B8BA',
  greyBorder: '#C6C6C6',
  searchIconColor: '#6F6F6F',
  white: '#FFFFFF',
  black: '#1f1f1f',
  mainFont: '#000000',
  badge: '#815D5D',
  error: '#CC0000',
  success: '#43A75A',
  darkGrey: '#8D8E8E',
  highlightable: '#66686859',
  hoverHighlightable: '#666868ab'
}

export default colors
